// @ts-nocheck
/* Starter Custom Code - Start */
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TextSeparatorPresentationProps } from "@store/Library/Components/Toolkit/TextSeparator";
import { boxStyles } from "@store/Themes/common/mixins/box";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";
/* Starter Custom Code - End */

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { BreakpointType, hiddenStyles } from "@store/Themes/common/mixins/common";

interface SignInSharedProps {
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    icon?: IconPresentationProps;
}

export interface StoreSignInProps {
    formTitle?: TypographyProps;
    requirementsGridItem?: GridItemProps;
    requirementsGridItemMobile?: GridItemProps;
    overlayOverrides?: SignInSharedProps;
}

const requirementsGridItemProps: GridItemProps = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-left: ${pxToRem(50)};
                    `,
                ],
                mediaOptions.min,
            )}
    `,
};

/* Starter Custom Code - Start */

interface SignInSharedProps {
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    icon?: IconPresentationProps;
}

export interface SignInProps extends SignInSharedProps {
    separator?: TextSeparatorPresentationProps;
    overlayOverrides?: SignInSharedProps;
    /* Store Custom Code - Start */
    formTitle?: TypographyProps;
    requirementsGridItem?: GridItemProps;
    requirementsGridItemMobile?: GridItemProps;
    /* Store Custom Code - End */
}

export const signInProps: SignInProps = {
    wrapper: {
        css: css`
            ${breakpoint("md")} {
                ${boxStyles(pxToRemArray([null, null, 20, 32, 48]))};
                height: 100%;
            }
        `,
    },
    title: {
        variant: "h4",
        forwardAs: "h2",
        css: css`
            margin-top: 0;
        `,
    },
    icon: {
        color: "primary",
        size: 60,
        css: spacingStyles(null, pxToRem(10)),
    },
    separator: {
        spacing: pxToRemArray([16]),
        extendedStyles: {
            text: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.smaller};
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                    line-height: ${x => x.theme.design.typography.lineHeight.small};
                `,
            },
        },
    },
    overlayOverrides: {
        wrapper: {
            css: css`
                &:not(#important) {
                    box-shadow: none;
                    padding: 0;
                    height: auto;
                    background: transparent;
                    border-radius: 0;
                }
            `,
        },
        title: {
            forwardAs: "p",
            css: css`
                font-size: ${x => x.theme.design.typography.size.large} !important;
            `,
        },
    },
    /* Store Custom Code - Start */
    formTitle: {
        as: "h2",
        variant: "h2",
    },
    requirementsGridItem: {
        ...requirementsGridItemProps,
        css: css`
            ${hiddenStyles(BreakpointType.Below, "sm")}
        `,
    },
    requirementsGridItemMobile: {
        ...requirementsGridItemProps,
        css: css`
            ${hiddenStyles(BreakpointType.Above, "md")}
        `,
    },
    /* Store Custom Code - End */
};
/* Starter Custom Code - End */
